export const DEFAULT_PROGRESS = {
  xp: 0,
  completedSets: [],
  unlockedContent: [],
  unlockedSkins: ['bribark', 'dollybelle'], // ✅ CAMBIO: unlockedSkins → unlockedSkins
  currentSkin: 'bribark',
};
